import { api } from "../../shared/api/axios";

export async function fetchPedidos({ origin, status, statusDate, search } = {}) {
  const params = { pageSize: 100 };
  if (origin) params.origin = origin;
  if (status) params.status = status;
  if (statusDate) params.statusDate = statusDate;
  if (search) params.search = search;
  const { data } = await api.get("/pedidos", { params });
  return Array.isArray(data) ? data : data.data ?? [];
}

export async function fetchPedidoById(id) {
  const { data } = await api.get(`/pedidos/${id}`);
  return data;
}
